import React from "react";
import { IdentifierField } from "../../../../common/components/IdentifierField";

/**
 * Componente custom para el campo Phonogram.isrc. Al salir del campo guarda el ISRC
 * en su forma de 12 caracteres y muestra el error o el aviso de la regla; el detalle
 * está en IdentifierField, común a los cuatro campos de identificadores.
 *
 * Llená/editá este archivo en `develop`. El generador lo emite como stub estable en
 * `base` (merge-safe). Recibe los mismos props que un control estándar del form.
 */
export interface PhonogramIsrcCustomFieldProps {
  value: any;
  onChange: (value: any) => void;
  error?: boolean;
  helperText?: string;
  label?: string;
  description?: string;
}

export const PhonogramIsrcCustomField: React.FC<PhonogramIsrcCustomFieldProps> = (
  props
) => <IdentifierField kind="isrc" optional {...props} />;
